import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { ReactComponent as SadIconBig } from 'common-assets/assets/icons/sadIconBig.svg';
import { Button, CustomButtonProps } from '../Button/Button';
import { Title } from '../Title/Title';
import { Card } from '../Card/Card';
import { Label } from '../Label/Label';
import clsx from "clsx";

import useStyles from './ErrorProcessPage.style';

export interface ErrorProcessPageProps {
  errorCode: string;
  onClick: () => void;
  customTitle?: string;
  customText?: string;
  customButtonText?: string;
  layout?: "standard" | "slim";
  buttonType?: CustomButtonProps["buttonType"];
  customTextSize?: "normal" | "small";
  hideButtons?: boolean;
}

const ErrorProcessPage: React.FC<ErrorProcessPageProps> = ({
  errorCode,
  onClick,
  customTitle,
  customText,
  customButtonText,
  layout = "standard",
  buttonType = "primary",
  customTextSize = "normal",
  hideButtons = false }) => {
  const c = useStyles({ layout });
  const [t] = useTranslation("components");
  const cardSize = layout === "slim" ? "small" : "big";
  const title = customTitle ?? t("error-process-page.title");
  const infoTextVariantSmall = {
    [c.infoTextSmall]: customTextSize === "small" };
  return (
    <Card fullWidth size={cardSize} className={c.root} testId="page-not-found">
      <SadIconBig className={c.icon} />
      <Title titleClassName={c.title} titleVariant="h3" titleComponent='h3' title={title} />
      <p className={clsx(c.infoText, infoTextVariantSmall)}>
        {customText ?? (
          <Trans i18nKey="error-process-page.info" ns="components">
            <></>
            <strong className={c.infoTextStrong}></strong>
          </Trans>
        )}
      </p>
      {!hideButtons && <div className={c.actionButtonWrapper}>
        <Button
          buttonType={buttonType}
          onClick={onClick}
        >
          {customButtonText
            ?? t("error-process-page.button-label")}
        </Button>
      </div>}
      <Label className={c.errorCode}>{`${t(
        "error-process-page.error-code"
      )} ${errorCode}`}</Label>
    </Card>
  );
};

export default ErrorProcessPage;
